<template>
  <div>
    <HeaderComponent :menu-id="7"></HeaderComponent>
    <div style="background-color: #FFFFFF;">
      <div class="peifu-container" style="width: 1200px; padding-bottom: 0;">
        <!-- 标题 -->
        <div class="title-ty" style="padding-bottom: 0px;">
          <div class="title-ty-y">SHUISHI GRADING</div>
          <div class="title-ty-z"><span>水石评级</span>关于我们</div>
        </div>
      </div>
      <img src="@/assets/image/guanyuwomen-1.jpg" alt="" style="width: 100%; margin-bottom: 100px;">
      <div style="width: 1300px; margin: 50px auto; display: flex; justify-content: space-between;">
        <div class="title-b-ty" style="width: 45%; font-size: 40px;">核心理念<br>一币一估值，全额赔付</div>
        <div style="width: 55%;">
          <p class="p-ty">水石评级，将对市场估值1000元以上的古钱币，进行定向估值。估值金额为具体价值
而非估值范围，并根据此估值，对修补品及伪品进行全额赔付。</p>
          <p class="p-ty" style="margin: 30px 0;">若发现水石评级钱币存在真伪、修补的问题，可向官方客服进行反馈，并将钱币寄回公
司进行复检。若确实存在问题，我们将于收到钱币后的三个工作日内，根据该枚钱币的
估值，进行全额赔付。</p>
          <p class="p-ty">这一承诺不仅彰显了我们对鉴定技术的自信，更体现了对客户权益的极致尊重。通过建立透明的复检流程与高效的赔付机制，我们致力于消除收藏交易中的信任壁垒，让每一次收藏都安心无忧。水石评级将持续优化服务体验，以专业、严谨、负责的态度，成为
您收藏路上最坚实的后盾，共同见证历史的传承与价值的绽放。</p>
        </div>
      </div>
      <img src="@/assets/image/guanyuwomen-2.jpg" alt="" style="width: 900px; margin: 100px auto 0 auto;">
      <div class="lianxi-container">
        <div class="lianxi-box">
          <div class="title-b-ty" style="font-size: 38px; vertical-align: middle;">联系我们 <span style="color: #DDB055;">•</span></div>
          <ul class="lianxi-list">
            <li class="lianxi-item">
              <div class="lianxi-item-1">电话</div>
              <div class="lianxi-item-2">15688892320(同微信)</div>
            </li>
            <li class="lianxi-item">
              <div class="lianxi-item-1">地址</div>
              <div class="lianxi-item-2">山东省济南市市中区二环南路</br>凯瑞大厦918室水石评级</div>
            </li>
          </ul>
          <div class="lianxi-item-img">
            <img src="@/assets/image/gongzhonghao.png" alt="">
            <div>微信公众号</div>
          </div>
          <div class="lianxi-item-img">
            <img src="@/assets/image/douyinhao.png" alt="">
            <div>官方抖音号</div>
          </div>
        </div>
      </div>
    </div>
    <FooterComponent></FooterComponent>
  </div>
</template>

<script>
import HeaderComponent from '@/components/HeaderComponent.vue'
import FooterComponent from '@/components/FooterComponent.vue'

export default {
  data() {
    return {
    }
  },
  methods: {
  },
  components: {
    HeaderComponent,
    FooterComponent
  },
  created() {
  },
}
</script>
<style lang="less" scoped>
.lianxi-container{
  background-color: #000;
  .lianxi-box{
    width: 1200px;
    margin: 0 auto; 
    padding: 50px 0 30px;
    display: flex;
    justify-content: space-between;
    color: #fff;
  }
}
.lianxi-list{
  width: 40%;
  padding-left: 20px;
}
.lianxi-item{
  margin-bottom: 40px;
  .lianxi-item-1{
    font-size: 14px;
    letter-spacing: 1px;
    margin-bottom: 5px;
    color: #ccc;
  }
  .lianxi-item-2{
    font-size: 20px;
  }
}
.lianxi-item-img{
  padding-top: 20px;
  img{
    width: 120px;
  }
  div{
    font-size: 16px;
    text-align: center;
    margin-top: 5px;
  }
}
</style>